/**
 * 개인정보 보호정책 페이지
 *
 * 공통 LegalPageLayout을 사용하여 개인정보 보호정책을 표시합니다.
 */

import { LegalPageLayout } from './legal';
import { privacyContent } from './legal/privacyContent';
import { useLanguage } from '@/contexts/AppContext';

interface PrivacyPolicyPageProps {
  onBack: () => void;
}

export function PrivacyPolicyPage({ onBack }: PrivacyPolicyPageProps) {
  const { locale } = useLanguage();
  // #522: 법률 문서는 ko/es/en 만 법무 검토 완료 — 미보유 locale 은 es(멕시코 법적 기준) fallback
  const content = privacyContent[locale] ?? privacyContent.es;

  return (
    <LegalPageLayout
      title={content.title}
      lastUpdated={content.lastUpdated}
      intro={content.intro}
      sections={content.sections}
      onBack={onBack}
    />
  );
}
